import React, { ReactElement, useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { SideMenuOptionInterface } from '../../shared';
import { filterMenuByPermissions } from '../../page/TenantAdminDashboard/util';
import useAuth from '../../hooks/useAuth';

interface ProtectedRouteProps {
  requiredPermissions?: string[]; // brak = dostępne dla wszystkich
  menuOptions: SideMenuOptionInterface[];
  element: ReactElement;
  tenantId: string;
}

const flattenLinks = (menu: SideMenuOptionInterface[]): string[] => {
  const links: string[] = [];

  const traverse = (items: any[]) => {
    for (const item of items) {
      if (item.link) {
        const base = `/tenantAdmin/${item.link}`.replace(/\/$/, '');
        links.push(base);
      }
      if (item.children) {
        traverse(item.children);
      }
    }
  };

  traverse(menu);
  return links;
};

export const ProtectedRoute = ({
  requiredPermissions = [],
  menuOptions,
  element,
  tenantId
}: ProtectedRouteProps) => {
  const { auth } = useAuth();
  const location = useLocation();

  const availableModules = auth.loggedUserDto?.availableModules || [];

  const hasPermission =
    requiredPermissions.length === 0 ||
    requiredPermissions.some((perm) => availableModules.includes(perm));

  const filteredMenu = useMemo(
    () => filterMenuByPermissions(menuOptions, availableModules),
    [menuOptions, availableModules]
  );

  const allowedLinks = flattenLinks(filteredMenu);

  if (!auth.loggedUserDto) return null; // lub spinner

  if (!hasPermission) {
    const redirectTo = allowedLinks[0] || '/instructions';
    return <Navigate to={redirectTo} replace state={{ from: location }} />;
  }

  return element;
};
